import React from 'react';
import { Level } from 'rbx';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Heading } from '../../../components/elements';

const Wrapper = styled.div`
  padding: 1rem 1rem;
  border-bottom: 1px solid #f6f6f6;
`;

const Header = () => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Heading>Google Order Feed</Heading>
      </Level.Item>
      <Level.Item align="right">
        <Link to="/add-google-place-feed" className="button is-primary">
          <span className="has-text-weight-semibold">
            Add a Order Food Place
          </span>
        </Link>
      </Level.Item>
    </Level>
  </Wrapper>
);

export default Header;
